<template>
  <span>
    {{ salaryFormatted }}
  </span>
</template>

<script>
import useNumberFormatter from '@/compositions/useNumberFormatter';
import {
  toRefs,
  watch,
  ref,
} from '@vue/composition-api';

export default {
  name: 'VacancySalary',
  props: {
    salary: {
      required: true,
      validator: value => value instanceof Object || value === null || value === undefined,
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    short: Boolean,
  },
  setup(props) {
    const { formatSalary, formatSalaryShort } = useNumberFormatter();
    const { salary, prefix, short } = toRefs(props);

    const salaryFormatted = ref(null);

    const formatMethod = short.value ? formatSalaryShort : formatSalary;

    watch(
      salary,
      (s) => {
        const formatted = formatMethod(s);

        salaryFormatted.value = prefix.value ? `${prefix.value} ${formatted}` : formatted;
      },
      { immediate: true },
    );

    return {
      salaryFormatted,
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  from: From
  to: to
  notProvided: Salary not provided
  year: per year
  month: per month
  week: per week
  day: per day
  hour: per hour
  net: ''
  gross: ''
</i18n>

<i18n locale="ru" lang="yaml">
  from: от
  to: до
  notProvided: з/п не указана
  year: в год
  month: в месяц
  week: в неделю
  day: в день
  hour: в час
  net: до вычета НДФЛ
  gross: на руки
</i18n>
